import { createContext } from 'react';

/**
 * Shared by SDKChatView so a pending capability request (a listener or
 * action the agent wants approved) lifts out of the transcript into a slot
 * docked above the composer, where it stays in reach whatever the scroll
 * position. Unlike an AskUserQuestion prompt it does not dim the transcript
 * or disable the composer: the agent may still be working, and the person
 * may want to keep talking to it while they decide.
 *
 * Once answered the card renders inline again, as a resolved line at the
 * point in the thread where the agent asked.
 *
 * With no provider (a renderer story mounting the card directly) `enabled`
 * is false and the card renders inline.
 */
export interface CapabilityDockContextValue {
  enabled: boolean;
  /** Portal target for pending cards. Null until the slot mounts. */
  dockEl: HTMLElement | null;
}

export const CapabilityDockContext = createContext<CapabilityDockContextValue>({
  enabled: false,
  dockEl: null,
});
